import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

import { fetchAuthSession } from 'aws-amplify/auth';
import { AUTH_TYPE, AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import './init';

if (!import.meta.env.VITE_AWS_DEFAULT_REGION || !import.meta.env.VITE_GRAPHQL_API_URL) {
    const errorMessage = 'Required config unavailable';
    console.error(errorMessage, {
        apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
        region: import.meta.env.VITE_AWS_DEFAULT_REGION,
    });
    throw Error(errorMessage);
}

const auth: AuthOptions = {
    type: AUTH_TYPE.AWS_IAM,
    credentials: async () => (await fetchAuthSession()).credentials!,
};

const config = {
    auth,
    region: import.meta.env.VITE_AWS_DEFAULT_REGION,
    url: import.meta.env.VITE_GRAPHQL_API_URL,
};

const httpLink = new HttpLink({ uri: config.url });

const authLink = createAuthLink(config);

const subscriptionLink = createSubscriptionHandshakeLink(config, httpLink);

const splitLink = ApolloLink.split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    subscriptionLink,
    authLink.concat(httpLink)
);

export const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
    enhancedClientAwareness: { transport: false },
});
